import { PurchaseOrder } from "@models/PurchaseOrder";

const castNumber = (value: null | string | number) =>
  value ? Number(value) : 0;

export const calcTotalCostPurchaseOrder = (po: PurchaseOrder) => {
  return (
    castNumber(po.totalProductCost) +
    castNumber(po.totalFreightCost) +
    castNumber(po.totalTaxes) +
    castNumber(po.totalSetupFees)
  );
};
